var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 456.2 456.2",
    style: {
      enableBackground: "new 0 0 456.2 456.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#29ABE2"
    },
    d: "M233.68,73.405v103.82c0,6.7-5.43,12.13-12.13,12.13H35.86c-6.7,0-12.13-5.43-12.13-12.13V73.405 c0-6.7,5.43-12.13,12.13-12.13h185.69C228.25,61.275,233.68,66.705,233.68,73.405z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.73,
    y: 88.525,
    style: {
      fill: "#4D4D4D"
    },
    width: 209.95,
    height: 31.32
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FC7A51"
    },
    d: "M50.458,157.969c0,6.479,2.457,12.403,6.487,16.871c-0.563,0.066-1.125,0.091-1.696,0.091 c-9.367,0-16.962-7.596-16.962-16.962s7.596-16.962,16.962-16.962c0.571,0,1.133,0.025,1.696,0.091 C52.915,145.566,50.458,151.49,50.458,157.969z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F4D521"
    },
    cx: 75.695,
    cy: 157.969,
    r: 16.962
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 170.342,
    y: 123.366,
    style: {
      fill: "#86D359"
    },
    width: 262.128,
    height: 141.09
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#77BC4A"
    },
    d: "M417.468,163.006v62.27c-13.46,0-24.39,10.78-24.63,24.18h-182.87 c-0.24-13.4-11.17-24.18-24.63-24.18v-62.27c13.61,0,24.64-11.03,24.64-24.64h182.85 C392.828,151.976,403.858,163.006,417.468,163.006z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9DE58"
    },
    d: "M199.436,254.87c0,24.01-19.46,43.48-43.47,43.48c-1.08,0-2.15-0.04-3.21-0.12 c-6.27-0.46-12.18-2.25-17.43-5.09c-13.6-7.35-22.84-21.73-22.84-38.27s9.24-30.92,22.84-38.27c5.25-2.84,11.16-4.63,17.43-5.08 c1.06-0.08,2.13-0.12,3.21-0.12C179.977,211.4,199.436,230.86,199.436,254.87z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D6B71D"
    },
    cx: 155.963,
    cy: 254.871,
    r: 28.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808080"
    },
    d: "M335.892,21.58v291.23c0,11.92-9.66,21.58-21.59,21.58h-139.96c-11.92,0-21.59-9.66-21.59-21.58 V21.58c0-11.92,9.67-21.58,21.59-21.58h139.96C326.232,0,335.892,9.66,335.892,21.58z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.4,
    y: 44.136,
    style: {
      fill: "#2BE0C6"
    },
    width: 165.854,
    height: 240.215
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#4D4D4D"
    },
    cx: 244.325,
    cy: 310.031,
    r: 17.09
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M309.709,105.7H179.327c-1.551,0-2.809-1.258-2.809-2.809V67.509c0-1.551,1.258-2.809,2.809-2.809 h130.382c1.551,0,2.809,1.258,2.809,2.809v35.382C312.518,104.442,311.26,105.7,309.709,105.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9DE58"
    },
    d: "M309.709,147.7h-18.382c-1.551,0-2.809-1.258-2.809-2.809v-18.382c0-1.551,1.258-2.809,2.809-2.809 h18.382c1.551,0,2.809,1.258,2.809,2.809v18.382C312.518,146.442,311.26,147.7,309.709,147.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FC7A51"
    },
    d: "M309.709,183.7h-18.382c-1.551,0-2.809-1.258-2.809-2.809v-18.382c0-1.551,1.258-2.809,2.809-2.809 h18.382c1.551,0,2.809,1.258,2.809,2.809v18.382C312.518,182.442,311.26,183.7,309.709,183.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808080"
    },
    d: "M197.709,147.7h-18.382c-1.551,0-2.809-1.258-2.809-2.809v-18.382 c0-1.551,1.258-2.809,2.809-2.809h18.382c1.551,0,2.809,1.258,2.809,2.809v18.382C200.518,146.442,199.26,147.7,197.709,147.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808080"
    },
    d: "M235.042,147.7H216.66c-1.551,0-2.809-1.258-2.809-2.809v-18.382c0-1.551,1.258-2.809,2.809-2.809 h18.382c1.551,0,2.809,1.258,2.809,2.809v18.382C237.851,146.442,236.594,147.7,235.042,147.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808080"
    },
    d: "M272.376,147.7h-18.382c-1.551,0-2.809-1.258-2.809-2.809v-18.382 c0-1.551,1.258-2.809,2.809-2.809h18.382c1.551,0,2.809,1.258,2.809,2.809v18.382C275.185,146.442,273.927,147.7,272.376,147.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808080"
    },
    d: "M197.709,183.7h-18.382c-1.551,0-2.809-1.258-2.809-2.809v-18.382 c0-1.551,1.258-2.809,2.809-2.809h18.382c1.551,0,2.809,1.258,2.809,2.809v18.382C200.518,182.442,199.26,183.7,197.709,183.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808080"
    },
    d: "M235.042,183.7H216.66c-1.551,0-2.809-1.258-2.809-2.809v-18.382c0-1.551,1.258-2.809,2.809-2.809 h18.382c1.551,0,2.809,1.258,2.809,2.809v18.382C237.851,182.442,236.594,183.7,235.042,183.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808080"
    },
    d: "M272.376,183.7h-18.382c-1.551,0-2.809-1.258-2.809-2.809v-18.382 c0-1.551,1.258-2.809,2.809-2.809h18.382c1.551,0,2.809,1.258,2.809,2.809v18.382C275.185,182.442,273.927,183.7,272.376,183.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808080"
    },
    d: "M197.709,220.431h-18.382c-1.551,0-2.809-1.258-2.809-2.809V199.24 c0-1.551,1.258-2.809,2.809-2.809h18.382c1.551,0,2.809,1.258,2.809,2.809v18.382 C200.518,219.173,199.26,220.431,197.709,220.431z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808080"
    },
    d: "M235.042,220.431H216.66c-1.551,0-2.809-1.258-2.809-2.809V199.24 c0-1.551,1.258-2.809,2.809-2.809h18.382c1.551,0,2.809,1.258,2.809,2.809v18.382 C237.851,219.173,236.594,220.431,235.042,220.431z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808080"
    },
    d: "M272.376,220.431h-18.382c-1.551,0-2.809-1.258-2.809-2.809V199.24 c0-1.551,1.258-2.809,2.809-2.809h18.382c1.551,0,2.809,1.258,2.809,2.809v18.382 C275.185,219.173,273.927,220.431,272.376,220.431z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808080"
    },
    d: "M309.709,220.431h-18.382c-1.551,0-2.809-1.258-2.809-2.809V199.24 c0-1.551,1.258-2.809,2.809-2.809h18.382c1.551,0,2.809,1.258,2.809,2.809v18.382 C312.518,219.173,311.26,220.431,309.709,220.431z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 271.518,
    y: 90.7,
    style: {
      fill: "#999999"
    },
    width: 29,
    height: 7
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.32,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M335.892,21.58v291.23c0,11.92-9.66,21.58-21.59,21.58 h-2.86l-15.25-50.04l-73.21-240.21L209.532,0h104.77C326.232,0,335.892,9.66,335.892,21.58z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M330.292,275.2v68.85h-58.46c-5.53,0-10.54,2.24-14.17,5.86c-3.62,3.63-5.86,8.64-5.86,14.17 s-2.24,10.54-5.86,14.17c-3.63,3.62-8.63,5.86-14.17,5.86c-11.06,0-20.03-8.96-20.03-20.03V275.2H330.292z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 227.017,
    y: 290.2,
    style: {
      fill: "#999999"
    },
    width: 88,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.017,
    y: 312.484,
    style: {
      fill: "#999999"
    },
    width: 88,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.017,
    y: 334.768,
    style: {
      fill: "#999999"
    },
    width: 88,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.017,
    y: 357.052,
    style: {
      fill: "#999999"
    },
    width: 88,
    height: 10
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCCCC"
    },
    d: "M291.864,364.081v20.03h-60.089c5.533,0,10.541-2.241,14.171-5.859 c3.618-3.63,5.859-8.638,5.859-14.171s2.241-10.541,5.859-14.171c3.63-3.618,8.638-5.859,14.171-5.859s10.541,2.241,14.171,5.859 C289.623,353.541,291.864,358.548,291.864,364.081z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M404.552,349.91c-3.63-3.62-8.63-5.86-14.17-5.86h-118.55c5.54,0,10.54,2.24,14.17,5.86 c3.62,3.63,5.86,8.64,5.86,14.17v80.12l11.854,12l11.852-12l11.853,12l11.854-12l11.85,12l11.853-12l11.857,12l11.853-12 l11.861,12l11.862-12v-80.12C410.412,358.55,408.172,353.54,404.552,349.91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2F2F2"
    },
    d: "M410.412,364.08h-118.55c0-5.53-2.24-10.54-5.86-14.17c-3.63-3.62-8.63-5.86-14.17-5.86h118.55 c5.54,0,10.54,2.24,14.17,5.86C408.172,353.54,410.412,358.55,410.412,364.08z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 307.017,
    y: 373.484,
    style: {
      fill: "#999999"
    },
    width: 88,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.017,
    y: 395.768,
    style: {
      fill: "#999999"
    },
    width: 88,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.017,
    y: 418.052,
    style: {
      fill: "#999999"
    },
    width: 88,
    height: 10
  })), /*#__PURE__*/React.createElement("rect", {
    x: 175.582,
    y: 243.2,
    style: {
      fill: "#2496B5"
    },
    width: 129,
    height: 24.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.582,
    y: 243.2,
    style: {
      fill: "#29ABE2"
    },
    width: 129,
    height: 24.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.332,
    y: 250.2,
    style: {
      fill: "#2496B5"
    },
    width: 117.5,
    height: 10.5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M309.792,254.7h-98.05h-20.5c11.322,0,20.5,9.178,20.5,20.5l0,0h118.55l0,0 C330.292,263.878,321.114,254.7,309.792,254.7z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 135.329,
    y: 61.275,
    style: {
      opacity: 0.2,
      fill: "#4D4D4D",
      enableBackground: "new"
    },
    width: 17.422,
    height: 128.08
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#4D4D4D",
      enableBackground: "new"
    },
    d: "M152.757,211.52v86.71c-6.27-0.46-12.18-2.25-17.43-5.09 V216.6C140.577,213.76,146.487,211.97,152.757,211.52z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.892,
    y: 123.366,
    style: {
      opacity: 0.2,
      fill: "#4D4D4D",
      enableBackground: "new"
    },
    width: 13.927,
    height: 141.09
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPay);
export default __webpack_public_path__ + "static/media/pay.ee5d2721.svg";
export { ForwardRef as ReactComponent };